let deferredPrompt = null;

export const setDeferredPrompt = (event) => {
    deferredPrompt = event;
};

export const getDeferredPrompt = () => {
    return deferredPrompt;
};

export const clearDeferredPrompt = () => {
    deferredPrompt = null;
};
